document.addEventListener('click', (event) => {
  const promo = event.target.closest('[data-mega-menu-promo]');

  if (!promo) return;

  const detail = {
    menu_name: promo.dataset.menuName || '',
    promo_name: promo.dataset.promoName || '',
    destination: promo.href,
  };

  document.dispatchEvent(new CustomEvent('mega-menu-promo:click', { detail }));

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: 'mega_menu_promo_click', ...detail });
  }
});
